import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface LookupProviderByNamePayload {
  familyName: string;
  givenName?: string;
  serverType?: 'equator' | 'capricorn';
  clinicId?: string;
}

export const lookupProviderByNameApi = createAsyncThunk(
  'hl7/lookupProviderByName',
  async (payload: LookupProviderByNamePayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const searchParams = new URLSearchParams();
      searchParams.set('familyName', payload.familyName);
      if (payload.givenName) searchParams.set('givenName', payload.givenName);
      if (payload.serverType) searchParams.set('serverType', payload.serverType);
      if (payload.clinicId) searchParams.set('clinicId', payload.clinicId);
      const response = await fetch(
        `${HL7.PROVIDER_LOOKUP_BYNAME}?${searchParams.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Lookup failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
